export enum TcddSubSystemType {
  MAIN = 'main',
  SUB = 'sub'
}
